import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { Modal, message } from 'ant-design-vue';
import { createVNode } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { queryGoodsList, delGoods, onlineGoods, offlineGoods, exportGoods, batchDelete } from '@/api/goodsSetting';
import { handleExportFile, reportEvent, isSandboxEnv } from '@/common';
export default function useListEvent(selectedRowKeys) {
  const router = useRouter();
  const searchForm = ref({
    dbtId: '',
    prodChnl: '',
    fuzzy: '',
    prodType: '',
    approvalStatuses: '',
    publishStatuses: '',
    prodStatus: '',
    testStatus: null,
    os: ''
  });
  const total = ref(0); // 经过模糊筛选后符合条件的数据量
  const pageIndex = ref(1);
  const pageSize = ref(20);
  const dataSource = ref([]);
  const isDefault = ref(true);
  // 导出币种弹框控制
  const cModal = ref({
    visible: false,
    currency: ''
  });
  const columns = [{
    title: '序号',
    dataIndex: 'codeNumber',
    width: 60
  }, {
    title: '商品类型',
    dataIndex: 'prodType'
  }, {
    title: '内购ID',
    dataIndex: 'prodId',
    width: 200
  }, {
    title: '商品名称',
    dataIndex: 'prodName',
    key: 'prodName',
    width: 120
  }, {
    title: '商品描述',
    dataIndex: 'prodDescription',
    key: 'prodDescription',
    width: 200
  }, {
    title: '默认价格',
    dataIndex: 'prodPrice',
    width: 120
  }, {
    title: '审核状态',
    dataIndex: 'approvalStatus'
  }, {
    title: '同步状态',
    dataIndex: 'publishStatus'
  }, {
    title: '商品状态',
    dataIndex: 'prodStatus'
  }, {
    title: '审核类型',
    dataIndex: 'optType'
  },
  // 沙箱环境不显示操作列
  isSandboxEnv ? {} : {
    title: '操作',
    dataIndex: 'handle',
    width: 140,
    align: 'right',
    fixed: 'right'
  }];
  const columnsWeixin = [{
    title: '序号',
    dataIndex: 'codeNumber',
    width: 60
  }, {
    title: '商品类型',
    dataIndex: 'prodType'
  }, {
    title: '内购ID',
    dataIndex: 'prodId',
    width: 200
  }, {
    title: '商品名称',
    dataIndex: 'prodName',
    key: 'prodName',
    width: 120
  }, {
    title: '商品描述',
    dataIndex: 'prodDescription',
    key: 'prodDescription',
    width: 200
  }, {
    title: '默认价格',
    dataIndex: 'prodPrice',
    width: 120
  }, {
    title: '系统',
    dataIndex: 'os',
    width: 120
  }, {
    title: '审核状态',
    dataIndex: 'approvalStatus'
  }, {
    title: '同步状态',
    dataIndex: 'publishStatus'
  }, {
    title: '商品状态',
    dataIndex: 'prodStatus'
  }, {
    title: '审核类型',
    dataIndex: 'optType'
  },
  // 沙箱环境不显示操作列
  isSandboxEnv ? {} : {
    title: '操作',
    dataIndex: 'handle',
    width: 140,
    align: 'right',
    fixed: 'right'
  }];
  const appName = ref('');
  const tableLoading = ref(false);
  const canDelete = ref([]);
  const canDisable = ref([]);
  const canEnable = ref([]);
  const getData = async () => {
    var _searchForm$value, _dataSource$value;
    if (!((_searchForm$value = searchForm.value) !== null && _searchForm$value !== void 0 && _searchForm$value.prodChnl)) {
      return;
    }
    const startTime = new Date().getTime();
    tableLoading.value = true;
    try {
      const res = await queryGoodsList({
        ...searchForm.value,
        approvalStatuses: searchForm.value.approvalStatuses || searchForm.value.approvalStatuses === 0 ? [searchForm.value.approvalStatuses] : [],
        publishStatuses: searchForm.value.publishStatuses || searchForm.value.publishStatuses === 0 ? [searchForm.value.publishStatuses] : [],
        prodStatus: searchForm.value.prodStatus || searchForm.value.prodStatus === 0 ? searchForm.value.prodStatus : null,
        pageNum: 1,
        pageSize: 100000
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _res$data, _res$data2, _res$data3, _res$data4, _res$data5;
        // 如果渠道是谷歌,需要判断当前币种是不是USD,如果不是,则前端自己处理数据展示usd价格
        isDefault.value = true;
        if (searchForm.value.prodChnl == 'google' && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.list && ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.list.length) > 0 && ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.list[0].prodPriceCurrency) != 'USD') {
          // 人为插入美元展示价格
          res.data.list = res.data.list.map(item => {
            if (item.productNativePrice) {
              let usItem = item.productNativePrice.find(ele => {
                return ele.regionCode === 'US' && ele.regionName === '美国';
              });
              // 设置默认值
              if (usItem) {
                item.usProdPrice = usItem.prodPrice;
                item.usProdPriceCurrency = usItem.prodPriceCurrency;
              }
            }
            return item;
          });
          isDefault.value = false;
        }
        dataSource.value = ((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.list) || [];
        total.value = ((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.total) || 0;
        selectedRowKeys.value = [];
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '商品配置搜索',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'succeed'
          }
        });
      } else {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '商品配置搜索',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'failed'
          }
        });
      }
    } catch (error) {
      reportEvent({
        eventName: '_search',
        properties: {
          ui_name: '商品配置搜索',
          app_name: '',
          return_duration: (new Date().getTime() - startTime) / 1000,
          query_status: 'failed'
        }
      });
    }
    dataSource.value = (_dataSource$value = dataSource.value) === null || _dataSource$value === void 0 ? void 0 : _dataSource$value.map((item, index) => {
      item.codeNumber = (pageIndex.value - 1) * pageSize.value + index + 1; // 添加序号
      return item;
    });
    tableLoading.value = false;
  }; // 从后端查询源数据
  const goUpd = item => {
    const pushing = () => {
      router.push({
        name: 'goodsSettingDetail',
        query: {
          dbtId: searchForm.value.dbtId,
          prodChnl: searchForm.value.prodChnl,
          id: item.id,
          type: 'edit',
          skuId: item.skuId
        }
      });
    };
    if (item.publishStatus === 10) {
      // 同步状态成功的话介入提示
      Modal.confirm({
        title: '提示',
        icon: createVNode(ExclamationCircleOutlined),
        content: '该商品已生效，请修改商品信息后，再次提交审核，审核通过后商品信息更新。',
        okText: '确 定',
        okType: 'danger',
        cancelText: '取 消',
        onOk: () => {
          pushing();
        },
        onCancel() {}
      });
    } else {
      pushing();
    }
  }; //点击编辑去详情
  const goAdd = () => {
    if (!searchForm.value.prodChnl) {
      message.error('缺少商品渠道，无法新增');
      return;
    }
    router.push({
      name: 'goodsSettingDetail',
      query: {
        dbtId: searchForm.value.dbtId,
        prodChnl: searchForm.value.prodChnl
      }
    });
  }; // 点击新增去详情
  const searcher = () => {
    pageIndex.value = 1;
    getData();
  }; // 搜索事件
  const goDel = item => {
    Modal.confirm({
      title: '提示',
      icon: createVNode(ExclamationCircleOutlined),
      content: '确定要删除该商品吗?',
      okText: '确 定',
      okType: 'danger',
      cancelText: '取 消',
      onOk: async () => {
        try {
          const res = await delGoods({
            id: item.id,
            prodChnl: searchForm.value.prodChnl
          });
          if (res.code === '0') {
            message.success('删除成功');
            if (pageIndex.value > 1 && dataSource.value.length === 1) {
              pageIndex.value--;
            }
            getData();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '商品配置',
                element_name: '删除'
              }
            });
          }
        } catch (error) {}
      },
      onCancel() {}
    });
  }; // 删除事件
  const changePage = (val, size) => {
    pageIndex.value = val;
    pageSize.value = size;
    getData();
  }; // 分页事件
  const goOnline = async item => {
    const pushing = async () => {
      try {
        const res = await onlineGoods({
          productList: [{
            id: item.id
          }],
          prodChnl: searchForm.value.prodChnl
        });
        if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
          message.success('启用操作成功');
          getData();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '商品配置',
              element_name: '启用'
            }
          });
        }
      } catch (error) {}
    };
    if (item.publishStatus === 10) {
      Modal.confirm({
        title: '提示',
        icon: createVNode(ExclamationCircleOutlined),
        content: '该商品已失效，请在点击启用后再次提交审核，审核通过后商品将再次生效。',
        okText: '确 定',
        okType: 'danger',
        cancelText: '取 消',
        onOk: () => {
          pushing();
        },
        onCancel() {}
      });
    } else {
      pushing();
    }
  }; // 上线
  const goOffline = async item => {
    const pushing = async () => {
      try {
        const res = await offlineGoods({
          productList: [{
            id: item.id
          }],
          prodChnl: searchForm.value.prodChnl
        });
        if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
          message.success('停用操作成功');
          getData();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '商品配置',
              element_name: '停用'
            }
          });
        }
      } catch (error) {}
    };
    if (item.publishStatus === 10) {
      Modal.confirm({
        title: '提示',
        icon: createVNode(ExclamationCircleOutlined),
        content: '该商品已生效，请在点击停用后再次提交审核，审核通过后商品将失效。',
        okText: '确 定',
        okType: 'danger',
        cancelText: '取 消',
        onOk: () => {
          pushing();
        },
        onCancel() {}
      });
    } else {
      pushing();
    }
  }; // 下线
  // 渠道为google 需要判断当前结算币种是否为usd,不是则出弹框让用户选择是默认币种还是usd导出
  const queryExportType = async () => {
    if (searchForm.value.prodChnl == 'google' && dataSource.value.length > 0 && dataSource.value[0].prodPriceCurrency !== 'USD') {
      cModal.value = {
        visible: true,
        currency: dataSource.value[0].prodPriceCurrency
      };
    } else {
      exportGoodsExcel();
    }
  };
  const exportGoodsExcel = async (type = '', isCurrency = false) => {
    let params = {
      ...searchForm.value,
      approvalStatuses: searchForm.value.approvalStatuses || searchForm.value.approvalStatuses === 0 ? [searchForm.value.approvalStatuses] : [],
      publishStatuses: searchForm.value.publishStatuses || searchForm.value.publishStatuses === 0 ? [searchForm.value.publishStatuses] : [],
      ids: unref(selectedRowKeys)
    };
    if (type == 'US') {
      params = Object.assign(params, {
        regionOfCurrency: type
      });
    }
    handleExportFile(await exportGoods(params), `${appName.value}_商品表`, 'xls');
    // 接口调完关闭币种选择弹框
    if (isCurrency) {
      cModal.value.visible = false;
    }
    reportEvent({
      eventName: 'element_use',
      properties: {
        ui_name: '商品配置',
        element_name: '导出'
      }
    });
  }; // 导出
  // 动态列处理
  const dynamicColumns = () => {
    const excludeChnl = ['weixin', 'zijie', 'alipay', '4399', 'kuaishou', 'BanHao'];
    if (excludeChnl.includes(searchForm.value.prodChnl)) {
      if (searchForm.value.prodChnl === 'weixin') {
        return columnsWeixin;
      } else {
        return columns;
      }
    } else {
      return [...columns.filter(item => item.dataIndex !== 'handle'), {
        title: '审批人',
        dataIndex: 'approver',
        width: 120
      }, {
        title: '操作',
        dataIndex: 'handle',
        width: 140,
        align: 'right',
        fixed: 'right'
      }];
    }
  };
  const changeDefault = () => {
    isDefault.value = !isDefault.value;
  };
  const batchOperate = key => {
    let type = '删除',
      api = batchDelete,
      content = '',
      params = {
        prodChnl: searchForm.value.prodChnl
      };
    switch (key) {
      case '1':
        type = '删除';
        content = `确定要${type}这些商品吗?`;
        params = Object.assign(params, {
          ids: canDelete.value
        });
        api = batchDelete;
        break;
      case '2':
        type = '停用';
        content = `确定要${type}这些商品吗?`;
        const ids = canDisable.value.map(item => {
          return {
            id: item
          };
        });
        params = Object.assign(params, {
          productList: ids
        });
        api = offlineGoods;
        break;
      case '3':
        type = '启用';
        content = `确定要${type}这些商品吗?`;
        const offIds = canEnable.value.map(item => {
          return {
            id: item
          };
        });
        params = Object.assign(params, {
          productList: offIds
        });
        api = onlineGoods;
        break;
    }
    Modal.confirm({
      title: '提示',
      icon: createVNode(ExclamationCircleOutlined),
      content: content,
      okText: '确 定',
      okType: 'danger',
      cancelText: '取 消',
      onOk: async () => {
        try {
          const res = await api(params);
          if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
            message.success(`批量${type}操作成功`);
            getData();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '商品配置',
                element_name: `批量${type}`
              }
            });
          }
        } catch (error) {}
      },
      onCancel() {}
    });
  };
  return {
    total,
    pageIndex,
    pageSize,
    dataSource,
    columns,
    columnsWeixin,
    searchForm,
    appName,
    tableLoading,
    isDefault,
    cModal,
    canDelete,
    canDisable,
    canEnable,
    getData,
    searcher,
    goAdd,
    goDel,
    goUpd,
    goOnline,
    goOffline,
    changePage,
    exportGoodsExcel,
    dynamicColumns,
    changeDefault,
    queryExportType,
    batchOperate
  };
}